import React, { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import schema from "../../../../extras/schemas/equipmentLocation.schema";
import FormSelect from "../../../../components/forms/formSelect/FormSelect";
import FormInput from "../../../../components/forms/formInput/FormInput";
import { useOutletContext } from "react-router-dom";
import { useCities, useStates, useUpdateProduct } from "../../../../extras/services/queries";
import { toast } from "react-toastify";
import ReactInputMask from "react-input-mask";
import axios from "axios";

const EditEquipmentLocation = () => {
  const INPUTS_TO_CHANGE = ['trade_in', 'en_cep', 'en_state_id', 'en_city_id', 'en_address', 'en_district', 'en_number', 'en_complement'];
  const tradeInTypes = [
    { value: 1, label: "Sim" },
    { value: 0, label: "Não" },
  ];

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      en_city_id: null
    }
  });

  const [product, setProduct] = useOutletContext();
  const [cepInfo, setCepInfo] = useState(null);
  const { mutate, isPending } = useUpdateProduct();
  const { data: states, isPending: isLoadingState } = useStates();
  const { mutate: mutateCity, isPending: isLoadingCity } = useCities();

  const [cities, setCities] = useState([]);

  const onSubmit = (data) => {
    mutate({ ...data, id: product?.id }, {
      onSuccess: (res) => {
        if (res?.status == 200)
          toast.success("Informações atualizada com sucesso!");
      }
    })
  };

  const getInfosbyCep = (cep) => {
    axios.get(`https://viacep.com.br/ws/${cep}/json/`, { responseType: 'json' }).then((response) => {
      if (response.erro) {
        setCepInfo(null);
        return;
      }

      setCepInfo(response.data);
    });
  }

  useEffect(() => {
    if (!cepInfo)
      return;

    setTimeout(() => {
      const stateId = states?.data?.find(item => item.uf == cepInfo.uf).id;

      if (stateId)
        setValue('en_state_id', stateId);

      setValue('en_address', cepInfo?.logradouro);
      setValue('en_district', cepInfo?.bairro);
      setValue('en_complement', cepInfo?.complemento);
    }, 500)

  }, [JSON.stringify(cepInfo)])


  useEffect(() => {
    const cep = watch('en_cep');
    if (cep?.length == 8)
      getInfosbyCep(cep);

  }, [watch('en_cep')])

  useEffect(() => {
    if (product)
      Object.keys(product).forEach(chave => {
        if (INPUTS_TO_CHANGE.includes(chave))
          setValue(chave, product[chave]);
      });
  }, [JSON.stringify(product)])

  useEffect(() => {
    if (!watch("en_state_id") || isLoadingCity || isLoadingState)
      return;

    const watchCurrent = watch("en_city_id");

    mutateCity(watch("en_state_id"), {
      onSuccess: (city) => {
        setCities(city?.data);
        const checkValue = city?.data?.find(objeto => objeto.id === watchCurrent);
        const stateIdByApi = states?.data?.find(item => item.uf == cepInfo.uf).id;

        if (stateIdByApi == watch("en_state_id")) {
          const cityId = city?.data?.find(objeto => objeto.name.toLowerCase() === cepInfo.localidade.toLowerCase()).id;

          if (cityId)
            setValue("en_city_id", cityId);

          return;
        }

        if (watchCurrent === null || checkValue)
          setValue("en_city_id", product?.en_city_id);
        else
          setValue("en_city_id", "");
      }
    })
  }, [watch("en_state_id")])


  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* <FormSelect
          label="Filial"
          options={filialTypes}
          name="delearship_branch_id"
          register={register}
          error={errors?.filial}
        /> */}
        <FormSelect
          label="Repasse"
          options={tradeInTypes}
          name="trade_in"
          register={register}
          error={errors?.trade_in}
        />
        <div className="grid lg:grid-cols-3 lg:gap-5">
          <label className="mb-3 block">
            <span className="font-bold text-slate-700 mb-1 inline-block text-sm ml-1 dark:text-white">
              CEP
            </span>
            <ReactInputMask maskChar={null} onChange={(res) => setValue('en_cep', res.target.value.replace('-', ''))} mask="99999-999" value={getValues('en_cep')} className="py-3 px-4 dark:text-white text-slate-700 dark:bg-transparent placeholder:text-slate-300 dark:border-slate-800 outline-none border border-slate-100 rounded-lg w-full focus:border-[#06B0B4] dark:focus:border-[#06B0B4] focus:shadow-[0px_0px_0px_5px_rgba(6,_176,_180,_0.1)]" />
            {errors?.en_cep?.message && (
              <span className="text-red-500 text-sm">{errors?.en_cep?.message}</span>
            )}
          </label>
          <FormSelect
            label="Estado"
            options={states?.data?.map(item => ({
              label: `${item.uf} - ${item.name}`,
              value: item.id
            }))}
            isLoading={isLoadingState}
            name="en_state_id"
            register={register}
            error={errors?.en_state_id}
          />
          <FormSelect
            label="Cidade"
            options={cities?.map(item => ({
              label: item.name,
              value: item.id
            }))}
            name="en_city_id"
            register={register}
            isLoading={isLoadingCity}
            error={errors?.en_city_id}
          />
        </div>
        <div className="grid lg:grid-cols-2 lg:gap-5">
          <FormInput
            label="Endereço"
            placeholder="Insira o endereço"
            name="en_address"
            value={getValues('en_address')}
            register={register}
            error={errors?.en_address}
          />
          <FormInput
            label="Número"
            placeholder="Insira o número"
            name="en_number"
            register={register}
            error={errors?.en_number}
          />
        </div>
        <FormInput
          label="Bairro"
          placeholder="Insira o bairro"
          name="en_district"
          register={register}
          error={errors?.en_district}
        />
        <FormInput
          label="Complemento"
          placeholder="Insira o complemento"
          name="en_complement"
          register={register}
        />
        <button
          type="submit"
          className="font-medium bg-[#002772] text-white px-7 py-2 rounded-full hover:opacity-80"
        >
          Enviar
        </button>
      </form>
    </div>
  );
};

export default EditEquipmentLocation;
